import * as React from 'react'

function SvgInfoLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="188"
      height="114"
      viewBox="0 0 188 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.3"
        d="M85.1769 103.389C121.808 104.299 165.384 94.5774 169.421 52.9949C173.097 15.2656 135.48 -10.8 98.2284 6.19948C82.1574 13.5286 76.0986 30.2182 58.5484 35.2679C40.9983 40.3176 17.6547 36.9344 12.8153 60.4539C5.32108 96.8745 61.0741 102.797 85.1769 103.389Z"
        fill="#EBF5FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M93.9998 90.3327C112.409 90.3327 127.333 75.4088 127.333 56.9993C127.333 38.5899 112.409 23.666 93.9998 23.666C75.5903 23.666 60.6665 38.5899 60.6665 56.9993C60.6665 75.4088 75.5903 90.3327 93.9998 90.3327ZM93.9998 100.333C117.932 100.333 137.333 80.9317 137.333 56.9993C137.333 33.067 117.932 13.666 93.9998 13.666C70.0675 13.666 50.6665 33.067 50.6665 56.9993C50.6665 80.9317 70.0675 100.333 93.9998 100.333ZM100.667 40.3327C100.667 44.0146 97.6817 46.9993 93.9998 46.9993C90.3179 46.9993 87.3332 44.0146 87.3332 40.3327C87.3332 36.6508 90.3179 33.666 93.9998 33.666C97.6817 33.666 100.667 36.6508 100.667 40.3327ZM87.3332 60.3327V76.9993C87.3332 80.6812 90.3179 83.666 93.9998 83.666C97.6817 83.666 100.667 80.6812 100.667 76.9993V60.3327C100.667 56.6508 97.6817 53.666 93.9998 53.666C90.3179 53.666 87.3332 56.6508 87.3332 60.3327Z"
        fill="#3583E6"
      />
    </svg>
  )
}

export default SvgInfoLogo
